import { PaymentMethodComponent } from './payment-method/payment-method.component';

export const PlaidModals = [PaymentMethodComponent];

export * from './payment-method/payment-method.component';
